import { createContext, useCallback, useState } from 'react'
import Toast from '~components/Toast'

const ToastContext = createContext(
  {} as (
    severity: 'success' | 'error' | 'neutral',
    heading: string,
    onClick?: () => void,
    actionLabel?: string,
    duration?: 6000
  ) => void
)

export default ToastContext

export function ToastProvider({ children }) {
  const [duration, setDuration] = useState<number | null>(null)
  const [isOpen, setOpen] = useState(false)
  const [severity, setSeverity] = useState<'success' | 'error' | 'neutral'>('neutral')
  const [heading, setHeading] = useState('')
  /* eslint-disable */
  const [onClick, setOnClick] = useState<() => void>(() => {})
  const [actionLabel, setActionLabel] = useState('')

  const openToast = useCallback(function (
    severity: 'success' | 'error' | 'neutral',
    heading: string,
    onClick?: () => void,
    actionLabel?: string,
    duration = 6000
  ) {
    setSeverity(severity)
    setHeading(heading)
    setOpen(true)
    setOnClick(() => onClick)
    setActionLabel(actionLabel)
    setDuration(duration)
  },
  [])

  function handleClose() {
    setOpen(false)
  }

  function handleClick() {
    setOpen(false)
    onClick?.()
  }

  return (
    <ToastContext.Provider value={openToast}>
      <Toast
        duration={duration}
        severity={severity}
        heading={heading}
        isOpen={isOpen}
        onClose={handleClose}
        onClick={handleClick}
        actionLabel={actionLabel}
      />
      {children}
    </ToastContext.Provider>
  )
}
